import { Reveal, Overline } from "@/components/Reveal";
import { SERVICES, CONTACT, waLink } from "@/data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="noir grain py-24 md:py-36">
      <div className="gold-glow opacity-70" />
      <div className="section-pad relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <Overline>Spiritual Practices</Overline>
            <Reveal>
              <h2 className="font-serif-display text-[var(--cream)] text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
                Practices to support reflection, <span className="text-[var(--gold-bright)] italic">healing and growth.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <a
              href={waLink("Namaste! I'd like to explore a practice with Brahmsara.")}
              target="_blank"
              rel="noreferrer"
              data-testid="services-book-btn"
              className="shrink-0 font-sans-ui text-sm tracking-wide px-8 py-4 border border-[rgba(233,172,70,0.5)] text-[var(--cream)] rounded-full hover:bg-[var(--gold)] hover:text-[var(--noir)] hover:border-[var(--gold)] transition-colors duration-400"
            >
              Book a Practice
            </a>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[rgba(233,172,70,0.18)] border border-[rgba(233,172,70,0.18)]">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={i} delay={(i % 4) * 0.08}>
                <div data-testid={`service-card-${i}`} className="group relative bg-[var(--noir)] h-full p-8 md:p-9 transition-colors duration-500 hover:bg-[var(--noir-2)]">
                  <Icon size={30} strokeWidth={1.2} className="text-[var(--gold-bright)] mb-6 transition-transform duration-500 group-hover:scale-110 group-hover:-translate-y-1" />
                  <h3 className="font-serif-display text-[1.65rem] leading-tight mb-3 text-[var(--cream)]">{s.title}</h3>
                  <p className="font-sans-ui text-sm text-[var(--cream)]/60 leading-relaxed font-light">{s.desc}</p>
                  <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[var(--gold-bright)] group-hover:w-full transition-all duration-500" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
